// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import WantedListsСoincidences from './WantedListsСoincidences';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(WantedListsСoincidences);
